import type { PropertyCommunicationField, PropertyCommunicationPlaceholder } from '@/shared/api';
import type { InsertOption } from '@/shared/components';
import { KNOWN_FIELDS, PORTAL_LINK } from './tokenAnalysis';

/** Alle Felder für genau dieses Textfeld: erlaubte mit Beispielwert, die übrigen mit Sperrgrund. */
export function insertOptions(
  placeholders: PropertyCommunicationPlaceholder[],
  field: PropertyCommunicationField,
  text: string,
  examples: Record<string, string>,
): InsertOption[] {
  return Object.entries(KNOWN_FIELDS).map(([token, known]) => {
    const offered = placeholders.find((item) => item.token === token);
    const option = { token, label: offered?.label ?? known.label, example: examples[token] ?? '' };
    if (!offered) return { ...option, blocked: { short: known.unavailable, why: known.why } };
    if (!offered.allowedFields.includes(field)) {
      const why =
        token === PORTAL_LINK ? 'Der Gastportal-Link gehört in den Text – genau einmal.' : '';
      return { ...option, blocked: { short: 'nur im Text', why } };
    }
    if (token === PORTAL_LINK && text.includes(PORTAL_LINK)) {
      return {
        ...option,
        blocked: {
          short: 'steht schon im Text',
          why: 'Pro Nachricht genau einmal – dort, wo das Feld steht.',
        },
      };
    }
    return option;
  });
}
